// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3qLRi","obliqueLineWrap":"membershipbadge_obliqueLineWrap__34KJc","obliqueLine":"membershipbadge_obliqueLine__H_11f"};